import http, { addTokenAndKeyParams } from '@/utils/http'

export const sendCode = (data) => {
  return http({
    url: '/m/phonecode/send.json',
    method: 'post',
    data
  })
}
export const checkCode = (data) => {
  return http({
    url: '/m/code/check.json',
    method: 'post',
    data
  })
}
export const getInviter = (data) => {
  return http({
    url: '/m/friendsUpgrade/getPhone.json',
    params: addTokenAndKeyParams(data),
  })
}

export const openPackage = () => {
  return http({
    url: '/n/wx/shareConf?url=' + encodeURIComponent(document.location.href)
  })
}
